import React, { useState } from 'react';
import Aux from '../../hoc/Aux';
import * as actions from '../../store/actions/index';
import { useParams } from "react-router";
import { useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form';
import {Link } from "react-router-dom";
import { ROUTES } from '../../routes';
import useCustomTranslation from '../../hooks/useCustomTranslation';

const recreatePassword = (props) => {

  const { token } = useParams();
  const dispatch = useDispatch();
  const { register, setError, errors, handleSubmit } = useForm();
  const ct = useCustomTranslation();
  const [passwordVerified, setPasswordVerified] = useState(false);

  const onSubmit = data => {
    dispatch( actions.recreatePassword(data, token) ).then( (res) => {
      (res && res.errors)? errorHandling(res.errors) : setPasswordVerified(true)
    });
  } ;

  const errorHandling = (e) => {
    if ( Array.isArray(e['password']) ) {
      setError("password", {
              type: "manual",
              message: ct('form.register.errors.password.' + e['password'][0]['error'] )
            });
    }
  }

  const intialValues = {
    password: "",
  };

  const errorMessage = (errors, fieldName) => {
    return (errors[fieldName])?
       <div className="invalid-feedback">
          { ct('form.register.errors.' + fieldName + '.required') }
        </div> : null
  }

  return (
    <Aux>
      <div className="main-container">
         <div className="container">
            <div className="row justify-content-center">
               <div className="col-lg-11 col-xl-10">
                 { (passwordVerified === true)?
                    <div className="page-header">
         							<h1>Ihr neues Passwort</h1>
                         <div className="card card-note" style={{paddingTop: "20px"}}>
                           <div className="card-body">
                             <p className="lead" >{ ct('recreate_password.success.text') }</p>
                             <Link className="btn btn-primary btn-project" to={ROUTES.TO_LOGIN} style={{marginTop: "10px"}}>{ ct('recreate_password.success.link') }</Link>
                           </div>
                         </div>
         						</div>
                    :
                  <Aux>
                    <div className="page-header">
                       <h1>{ ct('recreate_password.headline') }</h1>
                       <p className="lead">{ ct('recreate_password.subheadline') }</p>
                    </div>
                    <div className="tab-content">
                       <div className="tab-pane fade show active" id="tasks" role="tabpanel" data-filter-list="card-list-body">
                          <div className="row content-list-head">
                             <div className="col-auto">

                               <form onSubmit={handleSubmit(onSubmit)}>
                                 <div className="form-group row align-items-center">
                                   <label className="col-3">{ ct('recreate_password.form.password.label') }</label>
                                   <div className="col">
                                      <input
                                        className={(errors.password)? "form-control is-invalid" : "form-control"}
                                        name="password"
                                        defaultValue={intialValues.password}
                                        ref={register({ required: true})} />
                                       { (errors.password)?
                                           <div className="invalid-feedback">
                                              {errors.password.message}
                                            </div> : null
                                        }
                                        { errors.password && !errors.password.message && errorMessage(errors, 'password') }
                                    </div>
                                 </div>
             										<div className="row justify-content-end">
             											<button type="submit" className="btn btn-primary btn-project">{ ct('recreate_password.form.button') }</button>
             										</div>
             									</form>
                             </div>
                          </div>
                       </div>
                    </div>
                </Aux>
              }
             </div>
          </div>
       </div>
    </div>
  </Aux>

  )
};

export default recreatePassword;



// WEBPACK FOOTER //
// ./src/components/Auth/RecreatePassword.js